// extracted by mini-css-extract-plugin
module.exports = {"offsiteSimilarDesignsSection":"OffsiteSimilarDesignsContainer_offsiteSimilarDesignsSection__lEiek"};